import React from 'react';
import KpiEventDimensionTrendService from '../KpiEventDimensionTrendService';

const OVERALL_PERFORMANCE_API =
  '/api/v1/dashboard/pc/overview_daily/overall_performance';

/** overall_performance 薄层适配组件的 props：仅解构 config/api/contentHeader，其余透传 */
interface IKpiOverallPerformanceDimensionTrendServiceProps {
  config?: Record<string, unknown> & { api?: string; };
  api?: string;
  contentHeader?: React.ReactNode;
  // 其余 props 透传给 KpiEventDimensionTrendService，未在此处使用
  [key: string]: unknown;
}

/**
 * overall_performance 专用：响应为 data.metrics_list，行内 metrics 为嵌套 value 结构。
 * 请求体仍由 KpiEventDimensionTrendService / kpiDimensionMetricsTrendBeforeRequest（trend_chart）生成。
 */
const KpiOverallPerformanceDimensionTrendService = (
  props: IKpiOverallPerformanceDimensionTrendServiceProps,
) => {
  const { config, api: apiProp, contentHeader, ...rest } = props || {};
  const mergedConfig = {
    logicalFlag: 'trend_chart',
    dimensionValueSource: 'row_field',
    ...config,
  };
  const api = apiProp ?? mergedConfig.api ?? OVERALL_PERFORMANCE_API;

  return (
    <KpiEventDimensionTrendService
      {...rest}
      api={api}
      config={mergedConfig}
      contentHeader={contentHeader}
    />
  );
};

export default KpiOverallPerformanceDimensionTrendService;
